import { placeApi } from 'yxt-biz-pc/packages/api';

export const getPlaceList = params => {
  return placeApi.get('places/reservations/pages', params);
};
export const getPlaceById = id => {
  return placeApi.get(`places/${id}`);
};
export const getCategories = () => {
  return placeApi.get('places/categories/trees');
};

export const getPlaceTypeList = () => {
  return placeApi.get('places/types/list');
};
export const getConflicts = (data) => {
  return placeApi.get('places/reservations/conflicts', data);
};
